
let $ = $ || window.jQuery;
let drag = function (dragSelector,moveSelector,scopeSelector,_callback) {
    let dragObj = $(dragSelector);
    if (dragObj.length === 0) {
        return false;
    }
    let moveObj = $(moveSelector);
    let scopeObj = scopeSelector? $(scopeSelector):$(window);
    if (!moveSelector) {
        moveObj = dragObj;
    }
    let gapX,gapY;
    let funStart = function(event) {
        selectionEmpty();
        let p = fixedPosition(this);
        gapX=event.clientX-p.left;
        gapY=event.clientY-p.top;
        $(document).on("mousemove",funMove);
        $(document).one("mouseup",funStop);
        //拖拽期间禁止iframe接收事件
        $('iframe').css('pointer-events', 'none');
        return false;
    }
    let funMove = function(e) {

        let x = e.clientX - gapX;
        let y = e.clientY - gapY;

        let cw=scopeObj.width() - moveObj.outerWidth(true);
        let ch=scopeObj.height() - moveObj.outerHeight(true);
        if (x < 0) {
            x = 0;
        } else if (x > cw) {
            x = cw;
        }

        if (y < 0) {
            y = 0;
        } else if (y > ch) {
            y = ch;
        }

        moveObj.css({
            'left': x + 'px',
            'top': y + 'px'
        });
        if (_callback) {
            _callback(x, y);
        }

        return false;
    }
    let funStop = function () {
        $(document).off("mousemove");
        //恢复iframe的事件接收
        $('iframe').css('pointer-events', 'auto');
    };
    dragObj.on("mousedown",funStart);

};

/**
 * 取消页面选中的文字以及其他内容
 */
function selectionEmpty() {
    document.selection && document.selection.empty && ( document.selection.empty(), 1)
    || window.getSelection && window.getSelection().removeAllRanges();
}

function fixedPosition(obj) {
    let win = $(window);
    return {
        left : $(obj).offset().left-win.scrollLeft(),
        top : $(obj).offset().top-win.scrollTop()
    }
}

export {
    drag,selectionEmpty,fixedPosition
}